import React, { useCallback } from 'react';
import Depot from '../../../../_shared/depot';
import useModal from '../../../../Overlays/Modal/useModal';
import BinaryFilterButton from '../../BinaryFilterButton';
import FilterModalMenuContainer from '../../FilterModalMenuContainer';
import FilterModalMenuContent from '../../FilterModalMenuContent';
const ModalFilterButtonWithoutRef = ({ label, value, selected = false, isMenuOpen = false, clearable = false, buttonClearLabel = '', menuHeading = '', menuContent, menuSelectButtonLabel, menuClearButtonLabel, menuDoneButtonLabel = '', onClick, onMenuSelectButtonClick, onClear, onDone, modalProps, ...commonProps }) => {
    // Modal hook
    const { openModalHandler, closeModalHandler, modalState } = useModal();
    const handleClick = useCallback(() => {
        onClick === null || onClick === void 0 ? void 0 : onClick();
        openModalHandler();
    }, [openModalHandler, onClick]);
    const handleDone = useCallback(() => {
        onDone === null || onDone === void 0 ? void 0 : onDone();
        closeModalHandler();
    }, [closeModalHandler, onDone]);
    return (React.createElement(React.Fragment, null,
        React.createElement(BinaryFilterButton, { label: label, value: value, hasMenu: true, selected: selected, isMenuOpen: isMenuOpen, buttonClearLabel: buttonClearLabel, onClick: handleClick, onClear: onClear, "aria-haspopup": true, "aria-expanded": isMenuOpen, "aria-pressed": selected, ...commonProps }),
        React.createElement(FilterModalMenuContainer, { closeModalHandler: handleDone, modalState: modalState, ...modalProps },
            React.createElement(FilterModalMenuContent, { menuHeading: menuHeading, menuSelectButtonLabel: menuSelectButtonLabel, menuClearButtonLabel: menuClearButtonLabel, menuDoneButtonLabel: menuDoneButtonLabel, clearable: clearable, onMenuSelectButtonClick: onMenuSelectButtonClick, onDone: handleDone, onClear: onClear }, menuContent))));
};
const ModalFilterButton = Depot.withRef(ModalFilterButtonWithoutRef);
ModalFilterButton.displayName = 'ModalFilterButton';
export default ModalFilterButton;
//# sourceMappingURL=index.js.map